export const artworks = [
  {
    id: 'art-001',
    slug: 'art-001',
    title: { fr: '1ère sculpture', en: '1st Sculpture' },
    material: { fr: 'acier', en: 'steel' },
    year: 1959,
    height: 'h 60 cm',
    images: {
      thumb: './images/artworks/thumbs/sans_titre-acier-1959.jpeg',
      full: './images/artworks/full/sans_titre-acier-1959.jpeg',
    },
  },
  {
    id: 'art-002',
    slug: 'art-002',
    title: { fr: 'sans titre', en: 'untitled' },
    material: { fr: 'acier', en: 'steel' },
    year: 1969,
    height: 'h 23 cm',
    images: {
      thumb: './images/artworks/thumbs/sans_titre-acier-1969.jpeg',
      full: './images/artworks/full/sans_titre-acier-1969.jpeg',
    },
  },
  {
    id: 'art-003',
    slug: 'art-003',
    title: { fr: 'Espace Magique', en: '' },
    material: { fr: 'acier forgé', en: 'forged steel' },
    year: 1974,
    height: 'h 40 cm',
    images: {
      thumb: './images/artworks/thumbs/espace_magique-acier-1974.jpeg',
      full: './images/artworks/full/espace_magique-acier-1974.jpeg',
    },
  },
  {
    id: 'art-004',
    slug: 'art-004',
    title: { fr: 'Souffle de Vie', en: '' },
    material: { fr: 'acier forgé', en: 'forged steel' },
    year: 1975,
    height: 'h 2m10',
    images: {
      thumb: './images/artworks/thumbs/souffle_de_vie-acier_forge-1975.jpeg',
      full: './images/artworks/full/souffle_de_vie-acier_forge-1975.jpeg',
    },
  },
  {
    id: 'art-005',
    slug: 'art-005',
    title: { fr: 'Manteau du Fer', en: '' },
    material: { fr: 'acier forgé', en: 'forged steel' },
    year: 1976,
    height: 'h 70 cm',
    images: {
      thumb: './images/artworks/thumbs/manteau_du_fer-acier_forge-1976.jpeg',
      full: './images/artworks/full/manteau_du_fer-acier_forge-1976.jpeg',
    },
  },
  {
    id: 'art-006',
    slug: 'art-006',
    title: { fr: 'Les Amants', en: '' },
    material: { fr: 'acier', en: 'steel' },
    year: 1976,
    height: 'h 1m10',
    images: {
      thumb: './images/artworks/thumbs/les_amants-acier_forge-1976.jpeg',
      full: './images/artworks/full/les_amants-acier_forge-1976.jpeg',
    },
  },
    {
    id: 'art-076',
    slug: 'art-076',
    title: { fr: 'Le Réveil du fer', en: '' },
    material: { fr: 'acier', en: 'steel' },
    year: 1976,
    height: 'h 40 cm',
    images: {
      thumb: './images/artworks/thumbs/le_reveil_du_fer-acier-forge-1976.jpeg',
      full: './images/artworks/full/le_reveil_du_fer-acier-forge-1976.jpeg',
    },
  },
  {
    id: 'art-007',
    slug: 'art-007',
    title: { fr: 'La Volonté du Feu', en: '' },
    material: { fr: 'acier', en: 'steel' },
    year: 1977,
    height: 'h 98 cm',
    images: {
      thumb: './images/artworks/thumbs/la_volonte_du_feu-acier-1977.jpeg',
      full: './images/artworks/full/la_volonte_du_feu-acier-1977.jpeg',
    },
  },
    {
    id: 'art-008',
    slug: 'art-008',
    title: { fr: 'Résonance', en: '' },
    material: { fr: 'acier forgé', en: 'forged steel' },
    year: 1978,
    height: 'h 1m35',
    images: {
      thumb: './images/artworks/thumbs/resonance-acier_forge-1978.jpeg',
      full: './images/artworks/full/resonance-acier_forge-1978.jpeg',
    },
  },
    {
    id: 'art-009',
    slug: 'art-009',
    title: { fr: "Le souffle d'Icare", en: '' },
    material: { fr: 'acier forgé nickelé', en: 'nickel-plated forged steel' },
    year: 1978,
    height: 'h 98 cm',
    images: {
      thumb: './images/artworks/thumbs/le_souffle_dicare-acier_forge-1978.jpeg',
      full: './images/artworks/full/le_souffle_dicare-acier_forge-1978.jpeg',
    },
  },
  {
    id: 'art-010',
    slug: 'art-010',
    title: { fr: 'Fernand', en: '' },
    material: { fr: 'plâtre', en: 'plaster' },
    year: 1979,
    height: 'h 1m70',
    images: {
      thumb: './images/artworks/thumbs/fernand-platre-1979.jpeg',
      full: './images/artworks/full/fernand-platre-1979.jpeg',
    },
  },
  {
    id: 'art-061',
    slug: 'art-061',
    title: { fr: 'Nocturne', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1979,
    height: 'h 50 cm',
    images: {
      thumb: './images/artworks/thumbs/nocturne-bronze-1979.jpeg',
      full: './images/artworks/full/nocturne-bronze-1979.jpeg',
    },
  },
  {
    id: 'art-062',
    slug: 'art-062',
    title: { fr: 'Coulée', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1980,
    height: 'h 45 cm',
    images: {
      thumb: './images/artworks/thumbs/coulee-bronze-1980.jpeg',
      full: './images/artworks/full/coulee-bronze-1980.jpeg',
    },
  },
  {
    id: 'art-063',
    slug: 'art-063',
    title: { fr: 'Abbaye de Tournus', en: '' },
    material: { fr: 'Exposition personnelle', en: 'Personal Exhibition' },
    year: 1980,
    images: {
      thumb: './images/artworks/thumbs/abbaye_de_tournus-exposition-1980.jpg',
      full: './images/artworks/full/abbaye_de_tournus-exposition-1980.jpg',
    },
  },
  {
    id: 'art-064',
    slug: 'art-064',
    title: { fr: 'Le Guerrier', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1980,
    height: 'h 2m70 cm',
    images: {
      thumb: './images/artworks/thumbs/le-guerrier-bronze-1980.jpeg',
      full: './images/artworks/full/le-guerrier-bronze-1980.jpeg',
    },
  },
  {
    id: 'art-011',
    slug: 'art-011',
    title: { fr: 'Eclosion', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1980,
    height: 'h 65 cm',
    images: {
      thumb: './images/artworks/thumbs/eclosion-bronze-1980.jpeg',
      full: './images/artworks/full/eclosion-bronze-1980.jpeg',
    },
  },
  {
    id: 'art-012',
    slug: 'art-012',
    title: { fr: 'Chemin de Vie', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1980,
    height: 'h 1m10',
    images: {
      thumb: './images/artworks/thumbs/chemin_de_vie-bronze-1980.jpeg',
      full: './images/artworks/full/chemin_de_vie-bronze-1980.jpeg',
    },
  },
  {
    id: 'art-013',
    slug: 'art-013',
    title: { fr: 'Coulée Solaire', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1980,
    height: 'L 1m05',
    images: {
      thumb: './images/artworks/thumbs/coulee_solaire-bronze-1980.jpeg',
      full: './images/artworks/full/coulee_solaire-bronze-1980.jpeg',
    },
  },
  {
    id: 'art-014',
    slug: 'art-014',
    title: { fr: 'Présence', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1980,
    height: 'h 54 cm',
    images: {
      thumb: './images/artworks/thumbs/presence-bronze-1980.jpeg',
      full: './images/artworks/full/presence-bronze-1980.jpeg',
    },
  },
  {
    id: 'art-065',
    slug: 'art-065',
    title: { fr: 'Echo du Vent', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1980,
    height: 'h 55 cm',
    images: {
      thumb: './images/artworks/thumbs/echo_du_vent-bronze-1980.jpeg',
      full: './images/artworks/full/echo_du_vent-bronze-1980.jpeg',
    },
  },
  {
    id: 'art-066',
    slug: 'art-066',
    title: { fr: 'Cristal de Bronze', en: '' },
    material: { fr: 'Fontaine - bronze', en: 'bronze fountain' },
    year: 1980,
    height: 'h 1m55',
    images: {
      thumb: './images/artworks/thumbs/cristal_de_bronze-bronze-1980.jpeg',
      full: './images/artworks/full/cristal_de_bronze-bronze-1980.jpeg',
    },
  },
  {
    id: 'art-067',
    slug: 'art-067',
    title: { fr: 'Le Grand Guerrier', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1981,
    height: 'h 3m20',
    images: {
      thumb: './images/artworks/thumbs/le_grand_guerrier-bronze-1981.jpeg',
      full: './images/artworks/full/le_grand_guerrier-bronze-1981.jpeg',
    },
  },
  {
    id: 'art-015',
    slug: 'art-015',
    title: { fr: 'Source de Vie', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1982,
    height: 'h 1m70',
    images: {
      thumb: './images/artworks/thumbs/source_de_vie-bronze-1982.jpeg',
      full: './images/artworks/full/source_de_vie-bronze-1982.jpeg',
    },
  },
  {
    id: 'art-016',
    slug: 'art-016',
    title: { fr: 'Le Rêve Solaire', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1983,
    height: 'h 72 cm',
    images: {
      thumb: './images/artworks/thumbs/le_reve_solaire-bronze-1983.jpeg',
      full: './images/artworks/full/le_reve_solaire-bronze-1983.jpeg',
    },
  },
  {
    id: 'art-017',
    slug: 'art-017',
    title: { fr: "Fleur de l'Ame", en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1984,
    height: 'h 48 cm',
    images: {
      thumb: './images/artworks/thumbs/fleur_de_lame-bronze-1984.jpeg',
      full: './images/artworks/full/fleur_de_lame-bronze-1984.jpeg',
    },
  },
  {
    id: 'art-018',
    slug: 'art-018',
    title: { fr: 'Zenith', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1985,
    height: 'h 55 cm',
    images: {
      thumb: './images/artworks/thumbs/zenith-bronze-1985.jpeg',
      full: './images/artworks/full/zenith-bronze-1985.jpeg',
    },
  },
  {
    id: 'art-068',
    slug: 'art-068',
    title: { fr: 'Conversation', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1985,
    height: 'h 65 cm',
    images: {
      thumb: './images/artworks/thumbs/conversation-bronze-1985.jpeg',
      full: './images/artworks/full/conversation-bronze-1985.jpeg',
    },
  },
  {
    id: 'art-019',
    slug: 'art-019',
    title: { fr: 'Cosmos', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1986,
    height: 'h 67 cm',
    images: {
      thumb: './images/artworks/thumbs/cosmos-bronze-1986.jpeg',
      full: './images/artworks/full/cosmos-bronze-1986.jpeg',
    },
  },
  {
    id: 'art-020',
    slug: 'art-020',
    title: { fr: 'Dialogue', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1986,
    height: 'h 3m90',
    images: {
      thumb: './images/artworks/thumbs/dialogue-bronze-1986.jpeg',
      full: './images/artworks/full/dialogue-bronze-1986.jpeg',
    },
  },
  {
    id: 'art-021',
    slug: 'art-021',
    title: { fr: 'Hypnose', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1987,
    height: 'h 43 cm',
    images: {
      thumb: './images/artworks/thumbs/hypnose-bronze-1987.jpeg',
      full: './images/artworks/full/hypnose-bronze-1987.jpeg',
    },
  },
  {
    id: 'art-022',
    slug: 'art-022',
    title: { fr: 'Miroir', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1988,
    height: 'h 40 cm',
    images: {
      thumb: './images/artworks/thumbs/miroir-bronze-1988.jpeg',
      full: './images/artworks/full/miroir-bronze-1988.jpeg',
    },
  },
  {
    id: 'art-023',
    slug: 'art-023',
    title: { fr: 'Source d\'Energie', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1988,
    height: 'h 1m40',
    images: {
      thumb: './images/artworks/thumbs/source_energie-bronze-1988.jpeg',
      full: './images/artworks/full/source_energie-bronze-1988.jpeg',
    },
  },
  {
    id: 'art-026',
    slug: 'art-026',
    title: { fr: "L'Espace d'un Instant", en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1989,
    height: 'h 2m80',
    images: {
      thumb: './images/artworks/thumbs/lespace_dun_instant-bronze-1989.jpeg',
      full: './images/artworks/full/lespace_dun_instant-bronze-1989.jpeg',
    },
  },
  {
    id: 'art-024',
    slug: 'art-024',
    title: { fr: 'Regard', en: '' },
    material: { fr: 'Pièce murale - bronze', en: 'Wall piece - bronze' },
    year: 1989,
    height: 'h 1m50',
    images: {
      thumb: './images/artworks/thumbs/regard_1-bronze-1989.jpeg',
      full: './images/artworks/full/regard_1-bronze-1989.jpeg',
    },
  },
  {
    id: 'art-069',
    slug: 'art-069',
    title: { fr: 'Réminiscence', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1989,
    height: 'h 75 cm',
    images: {
      thumb: './images/artworks/thumbs/reminiscence-bronze-1989.jpeg',
      full: './images/artworks/full/reminiscence-bronze-1989.jpeg',
    },
  },
  {
    id: 'art-027',
    slug: 'art-027',
    title: { fr: 'Le Fils Prodigue', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1990,
    height: 'h 50 cm',
    images: {
      thumb: './images/artworks/thumbs/le_fils_prodigue-bronze-1990.jpeg',
      full: './images/artworks/full/le_fils_prodigue-bronze-1990.jpeg',
    },
  },
  {
    id: 'art-070',
    slug: 'art-070',
    title: { fr: 'Automne', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1990,
    height: 'h 55 cm',
    images: {
      thumb: './images/artworks/thumbs/automne-bronze-1990.jpeg',
      full: './images/artworks/full/automne-bronze-1990.jpeg',
    },
  },
  {
    id: 'art-071',
    slug: 'art-071',
    title: { fr: 'Le Coureur de Lune', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1990,
    height: 'h 55 cm',
    images: {
      thumb: './images/artworks/thumbs/le_coureur_de_lune-bronze-1990.jpg',
      full: './images/artworks/full/le_coureur_de_lune-bronze-1990.jpg',
    },
  },
  {
    id: 'art-028',
    slug: 'art-028',
    title: { fr: 'Le Messager', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1990,
    height: 'h 70 cm',
    images: {
      thumb: './images/artworks/thumbs/le_messager-bronze-1990.jpeg',
      full: './images/artworks/full/le_messager-bronze-1990.jpeg',
    },
  },
  {
    id: 'art-029',
    slug: 'art-029',
    title: { fr: 'Fleur de Lave', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1991,
    height: 'h 65 cm',
    images: {
      thumb: './images/artworks/thumbs/fleur_de_lave-bronze-1991.jpeg',
      full: './images/artworks/full/fleur_de_lave-bronze-1991.jpeg',
    },
  },
  {
    id: 'art-030',
    slug: 'art-030',
    title: { fr: 'Rêve doré', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1991,
    height: 'h 95 cm',
    images: {
      thumb: './images/artworks/thumbs/reve_dore-bronze-1991.jpeg',
      full: './images/artworks/full/reve_dore-bronze-1991.jpeg',
    },
  },
  {
    id: 'art-031',
    slug: 'art-031',
    title: { fr: 'La Joie Totale', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1991,
    height: 'h 34 cm',
    images: {
      thumb: './images/artworks/thumbs/la_joie_totale-bronze-1991.jpeg',
      full: './images/artworks/full/la_joie_totale-bronze-1991.jpeg',
    },
  },
  {
    id: 'art-032',
    slug: 'art-032',
    title: { fr: 'Coup de Foudre', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1991,
    height: 'h 30 cm',
    images: {
      thumb: './images/artworks/thumbs/coup_de_foudre-bronze-1991.jpeg',
      full: './images/artworks/full/coup_de_foudre-bronze-1991.jpeg',
    },
  },
  {
    id: 'art-033',
    slug: 'art-033',
    title: { fr: 'La Fiancée du Vent', en: '' },
    material: { fr: 'acier et bronze', en: 'steel and bronze' },
    year: 1991,
    height: 'h 40 cm',
    images: {
      thumb: './images/artworks/thumbs/la_fiancee_du_vent-acier_et_bronze-1991.jpeg',
      full: './images/artworks/full/la_fiancee_du_vent-acier_et_bronze-1991.jpeg',
    },
  },
  {
    id: 'art-075',
    slug: 'art-075',
    title: { fr: 'Liberté', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1991,
    height: 'h 1m40',
    images: {
      thumb: './images/artworks/thumbs/liberte-bronze-1991.jpeg',
      full: './images/artworks/full/liberte-bronze-1991.jpeg',
    },
  },
  {
    id: 'art-034',
    slug: 'art-034',
    title: { fr: 'Contact', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1992,
    height: 'h 1m50',
    images: {
      thumb: './images/artworks/thumbs/contact-bronze-1992.jpeg',
      full: './images/artworks/full/contact-bronze-1992.jpeg',
    },
  },
  {
    id: 'art-035',
    slug: 'art-035',
    title: { fr: 'Le Devenir', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1994,
    height: 'h 2m10',
    images: {
      thumb: './images/artworks/thumbs/le_devenir-bronze-1994.jpeg',
      full: './images/artworks/full/le_devenir-bronze-1994.jpeg',
    },
  },
  {
    id: 'art-036',
    slug: 'art-036',
    title: { fr: "L'Oeil du Monde", en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1994,
    height: 'h 1m10',
    images: {
      thumb: './images/artworks/thumbs/loeil_du_monde-bronze-1994.jpeg',
      full: './images/artworks/full/loeil_du_monde-bronze-1994.jpeg',
    },
  },
  {
    id: 'art-037',
    slug: 'art-037',
    title: { fr: 'Barrière de mots', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 1997,
    height: 'h 38 cm',
    images: {
      thumb: './images/artworks/thumbs/barriere_de_mots-bronze-1997.jpeg',
      full: './images/artworks/full/barriere_de_mots-bronze-1997.jpeg',
    },
  },
    {
    id: 'art-072',
    slug: 'art-072',
    title: { fr: "Le Nageur", en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2000,
    height: 'h 45 cm',
    images: {
      thumb: './images/artworks/thumbs/le_nageur-bronze-2000.jpeg',
      full: './images/artworks/full/le_nageur-bronze-2000.jpeg',
    },
  },
  {
    id: 'art-038',
    slug: 'art-038',
    title: { fr: 'Effleurer le Cosmos', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2002,
    height: 'h 75 cm',
    images: {
      thumb: './images/artworks/thumbs/effleurer_le_cosmos-bronze-2002.jpeg',
      full: './images/artworks/full/effleurer_le_cosmos-bronze-2002.jpeg',
    },
  },
  {
    id: 'art-039',
    slug: 'art-039',
    title: { fr: 'Coup de Vent', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2003,
    height: 'h 23 cm',
    images: {
      thumb: './images/artworks/thumbs/coup_de_vent-bronze-2003.jpeg',
      full: './images/artworks/full/coup_de_vent-bronze-2003.jpeg',
    },
  },
  {
    id: 'art-073',
    slug: 'art-073',
    title: { fr: 'Elévation', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2003,
    height: 'h 1m',
    images: {
      thumb: './images/artworks/thumbs/elevation-bronze-2003.jpeg',
      full: './images/artworks/full/elevation-bronze-2003.jpeg',
    },
  },
  {
    id: 'art-040',
    slug: 'art-040',
    title: { fr: 'La Reine Blanche', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2004,
    height: 'h 97 cm',
    images: {
      thumb: './images/artworks/thumbs/la_reine_blanche-bronze-2004.jpeg',
      full: './images/artworks/full/la_reine_blanche-bronze-2004.jpeg',
    },
  },
  {
    id: 'art-041',
    slug: 'art-041',
    title: { fr: 'sans titre', en: 'untitled' },
    material: { fr: 'acier forgé poli', en: 'polished forged steel' },
    year: 2005,
    height: 'h 51 cm',
    images: {
      thumb: './images/artworks/thumbs/1-acier_forge-2005.jpeg',
      full: './images/artworks/full/1-acier_forge-2005.jpeg',
    },
  },
  {
    id: 'art-042',
    slug: 'art-042',
    title: { fr: 'sans titre', en: 'untitled' },
    material: { fr: 'acier forgé poli', en: 'polished forged steel' },
    year: 2005,
    height: 'h 51 cm',
    images: {
      thumb: './images/artworks/thumbs/2-acier_forge-2005.jpeg',
      full: './images/artworks/full/2-acier_forge-2005.jpeg',
    },
  },
  {
    id: 'art-043',
    slug: 'art-043',
    title: { fr: 'sans titre', en: 'untitled' },
    material: { fr: 'acier forgé poli', en: 'polished forged steel' },
    year: 2006,
    height: 'h 70 cm',
    images: {
      thumb: './images/artworks/thumbs/3-acier_forge-2006.jpeg',
      full: './images/artworks/full/3-acier_forge-2006.jpeg',
    },
  },
  {
    id: 'art-074',
    slug: 'art-074',
    title: { fr: 'Veines de Bronze', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2006,
    height: 'h 80 cm',
    images: {
      thumb: './images/artworks/thumbs/veines_de_bronze-bronze-2006.jpeg',
      full: './images/artworks/full/veines_de_bronze-bronze-2006.jpeg',
    },
  },
  {
    id: 'art-044',
    slug: 'art-044',
    title: { fr: "L'Appel", en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2007,
    height: 'h 4m',
    images: {
      thumb: './images/artworks/thumbs/lappel-bronze-2007.jpeg',
      full: './images/artworks/full/lappel-bronze-2007.jpeg',
    },
  },
  {
    id: 'art-045',
    slug: 'art-045',
    title: { fr: "L'Appel", en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2007,
    height: 'h 4m',
    images: {
      thumb: './images/artworks/thumbs/lappel-bronze-2007(2).jpeg',
      full: './images/artworks/full/lappel-bronze-2007(2).jpeg',
    },
  },
  {
    id: 'art-046',
    slug: 'art-046',
    title: { fr: 'Empreinte Cosmique', en: '' },
    material: { fr: 'Pièce murale - bronze', en: 'Wall piece - bronze' },
    year: 2007,
    height: 'h 1m10',
    images: {
      thumb: './images/artworks/thumbs/empreinte_cosmique-bronze-2007.jpeg',
      full: './images/artworks/full/empreinte_cosmique-bronze-2007.jpeg',
    },
  },
  {
    id: 'art-047',
    slug: 'art-047',
    title: { fr: "Equilibre de l'instant", en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2008,
    height: 'h 60 cm',
    images: {
      thumb: './images/artworks/thumbs/equilibre_de_linstant-bronze-2008.jpeg',
      full: './images/artworks/full/equilibre_de_linstant-bronze-2008.jpeg',
    },
  },
  {
    id: 'art-048',
    slug: 'art-048',
    title: { fr: 'Regard de Nuit', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2008,
    height: 'h 1m10',
    images: {
      thumb: './images/artworks/thumbs/regard_de_nuit-bronze-2008.jpeg',
      full: './images/artworks/full/regard_de_nuit-bronze-2008.jpeg',
    },
  },
  {
    id: 'art-049',
    slug: 'art-049',
    title: { fr: 'Chemin de Vie', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2010,
    height: 'h 1m10',
    images: {
      thumb: './images/artworks/thumbs/chemin_de_vie-bronze-2010.jpeg',
      full: './images/artworks/full/chemin_de_vie-bronze-2010.jpeg',
    },
  },
  {
    id: 'art-050',
    slug: 'art-050',
    title: { fr: 'Voltige', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2011,
    height: 'h 1m40',
    images: {
      thumb: './images/artworks/thumbs/voltige-bronze-2011.jpeg',
      full: './images/artworks/full/voltige-bronze-2011.jpeg',
    },
  },
  {
    id: 'art-051',
    slug: 'art-051',
    title: { fr: "L'Ombre", en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2011,
    height: 'h 39 cm',
    images: {
      thumb: './images/artworks/thumbs/lombre-bronze-2011.jpeg',
      full: './images/artworks/full/lombre-bronze-2011.jpeg',
    },
  },
  {
    id: 'art-052',
    slug: 'art-052',
    title: { fr: 'Naissance', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2011,
    height: 'h 80 cm',
    images: {
      thumb: './images/artworks/thumbs/naissance-bronze-2011.jpeg',
      full: './images/artworks/full/naissance-bronze-2011.jpeg',
    },
  },
  {
    id: 'art-053',
    slug: 'art-053',
    title: { fr: 'Reflet', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2012,
    height: 'h 37 cm',
    images: {
      thumb: './images/artworks/thumbs/reflet-bronze-2012.jpeg',
      full: './images/artworks/full/reflet-bronze-2012.jpeg',
    },
  },
  {
    id: 'art-054',
    slug: 'art-054',
    title: { fr: 'Confiance', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2012,
    height: 'h 29 cm',
    images: {
      thumb: './images/artworks/thumbs/confiance-bronze-2012.jpeg',
      full: './images/artworks/full/confiance-bronze-2012.jpeg',
    },
  },
  {
    id: 'art-055',
    slug: 'art-055',
    title: { fr: 'Regard II', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2012,
    height: 'h 49 cm',
    images: {
      thumb: './images/artworks/thumbs/regard_ii-bronze-2012.jpeg',
      full: './images/artworks/full/regard_ii-bronze-2012.jpeg',
    },
  },
  {
    id: 'art-056',
    slug: 'art-056',
    title: { fr: 'Talisman', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2013,
    height: 'h 50 cm',
    images: {
      thumb: './images/artworks/thumbs/talisman-bronze-2013.jpeg',
      full: './images/artworks/full/talisman-bronze-2013.jpeg',
    },
  },
  {
    id: 'art-057',
    slug: 'art-057',
    title: { fr: 'Sérénité', en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2013,
    height: 'h 28 cm',
    images: {
      thumb: './images/artworks/thumbs/serenite-bronze-2013.jpeg',
      full: './images/artworks/full/serenite-bronze-2013.jpeg',
    },
  },
  {
    id: 'art-058',
    slug: 'art-058',
    title: { fr: 'Sérénité', en: '' },
    material: { fr: 'porcelaine', en: 'porcelain' },
    year: 2013,
    height: 'h 24 cm',
    images: {
      thumb: './images/artworks/thumbs/serenite-porcelaine-2013.jpeg',
      full: './images/artworks/full/serenite-porcelaine-2013.jpeg',
    },
  },
  {
    id: 'art-059',
    slug: 'art-059',
    title: { fr: 'Sérénité', en: '' },
    material: { fr: 'verre', en: 'glass' },
    year: 2013,
    height: 'h 28 cm',
    images: {
      thumb: './images/artworks/thumbs/serenite-verre-2013.jpeg',
      full: './images/artworks/full/serenite-verre-2013.jpeg',
    },
  },
  {
    id: 'art-060',
    slug: 'art-060',
    title: { fr: "L'Appel II", en: '' },
    material: { fr: 'bronze', en: 'bronze' },
    year: 2015,
    height: 'h 83 cm',
    images: {
      thumb: './images/artworks/thumbs/lappel_ii-2015.jpeg',
      full: './images/artworks/full/lappel_ii-2015.jpeg',
    },
  },
];
